import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatButtonModule } from "@angular/material/button";
import { RekbotNotesService } from '../../../../services/rekbots-notes.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { RekbotNote } from '../../rekbot-layout-models/rekbot-note.model';
import { NotificationService } from '../../../../services/notification.service';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-rekbot-add-note',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatButtonModule,
    CommonModule,
    MatIcon,
    RouterLink
],
  templateUrl: './rekbot-add-note.component.html',
  styleUrl: './rekbot-add-note.component.css'
})
export class RekbotAddNoteComponent implements OnInit{

  rekbotId!: number;
  selectedFiles?: File[];

  noteForm: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required]),
    note: new FormControl('', [Validators.required]),
    noteType: new FormControl('', [Validators.required]),
    attachments: new FormControl(null),
  })

  constructor(
    private rekbotNotesService: RekbotNotesService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.rekbotId = this.route.parent?.snapshot.params['rekbotId']
  }

  onSubmit() {
    console.log("submited");
    if(this.noteForm.valid) {
      const body: RekbotNote = new RekbotNote (
        this.noteForm.get('title')!.value,
        this.noteForm.get('note')!.value,
        this.noteForm.get('noteType')!.value
        
      )

      let addNoteSub;
      if(this.selectedFiles && this.selectedFiles.length > 0) {
        const formData = new FormData();
        formData.append('title', body.title);
        formData.append('note', body.note);
        formData.append('note_type', body.note_type);
        this.selectedFiles.forEach(file => {
          formData.append('attachment', file, file.name); // trzeci argument to nazwa pliku
        });
        addNoteSub = this.rekbotNotesService.addNote(this.rekbotId, formData)
        console.log("wysyłanie z attachments");
        
      } else {
        addNoteSub = this.rekbotNotesService.addNote(this.rekbotId, body)
      }
      console.log("Wysyłane body",body , "do rekbota" + this.rekbotId);
      // this.rekbotNotesService.addNote(this.rekbotId, body)
      addNoteSub
      .subscribe({
        next: res => {
          console.log(res);
          this.notificationService.pushNotification("Notatka dodana","info",5000);
          this.router.navigate(['../'], { relativeTo: this.route });
        },
        error: err => {
          console.error(err);
          
          this.notificationService.pushNotification("Coś poszło nie tak :/","info",5000)
        }
      });
    }
  }

  onFileSelected(event: any) {

    this.selectedFiles = this.selectedFiles ? [...this.selectedFiles, ...Array.from(event.target.files).filter((file: any) => !this.selectedFiles?.some(f => f.name === file.name))] as File[] : Array.from(event.target.files) as File[];

    // if(this.selectedFiles?.find(file => file.name === event.target.files[0].name)) {
    //   this.notificationService.pushNotification("Ten plik został już dodany","warning",3000);
    //   return;
    // } else {
    //   this.selectedFiles = this.selectedFiles ? [...this.selectedFiles, ...Array.from(event.target.files)] as File[] : Array.from(event.target.files) as File[];
    //   // Możesz też ustawić w FormControl, jeśli chcesz
    //   this.noteForm.patchValue({
    //     attachments: this.selectedFiles
    //   });
    // }
    
  }

  onDeleteFile(file: File) {
    this.selectedFiles = this.selectedFiles?.filter(f => f.name !== file.name);
    this.noteForm.patchValue({
      attachments: this.selectedFiles
    });
  }
}
